module.exports = __webpack_public_path__ + "static/media/pakturk.878b653a.jpg";